import { login, logout, getInfo } from '@/api/user'
// api [ 获取门店列表 ]
import { getAllStoreName } from "@/api/couponMana/bindingCoupon/index"
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_NICKNAME: (state, nickname) => {
    state.nickname = nickname
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_REMARK: (state, remark) => {
    state.remark = remark
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_LAST_LOGIN_TIME: (state, lastLoginTime) => {
    state.lastLoginTime = lastLoginTime
  },
  // 门店列表
  SET_STORE_LIST: (state, storeList) => {
    state.storeList = storeList
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('验证失败，请再次登录')
        }
        const { mobile, username, name, email, nickname, avatar, introduction, remark, lastLoginTime, id } = data

        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_MOBILE', mobile)
        commit('SET_USERNAME', username)
        commit('SET_EMAIL', email)
        commit('SET_NICKNAME', nickname)
        commit('SET_INTRODUCTION', introduction)
        commit('SET_REMARK', remark)
        commit('SET_LAST_LOGIN_TIME', lastLoginTime)
        commit('SET_ID', id)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取门店列表
  getStoreList({ commit, state }) {
    return new Promise((resolve, reject) => {
      getAllStoreName(state.token).then(response => {
        const { data } = response
        commit('SET_STORE_LIST', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      removeToken() // must remove  token  first
      resetRouter()
      commit('RESET_STATE')
      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

